import { ContainerModule } from 'inversify';
import { TYPES } from './types';
import ClientReqData from '@framework/router/Next/headers/ClientReqData';

export const nonceModule = new ContainerModule(({ bind }) => {
  bind(TYPES.Nonce).toDynamicValue(async ({ getAsync }) => {
    const { headers } = await getAsync(ClientReqData);
    return headers['x-nonce'] || '';
  })
    .inSingletonScope();
});
